module.exports = __webpack_public_path__ + "img/safety.e9ea6bab.jpg";